import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Soavina Atmosphere Padel</h3>
            <p className="text-gray-400">
              Votre destination premium pour le padel et les sports de raquette.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <a href="tel:+123456789" className="flex items-center space-x-2 text-gray-400 hover:text-white">
                <Phone className="h-5 w-5" />
                <span>+123 456 789</span>
              </a>
              <a href="mailto:contact@soavinapadel.com" className="flex items-center space-x-2 text-gray-400 hover:text-white">
                <Mail className="h-5 w-5" />
                <span>contact@soavinapadel.com</span>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li><a href="/booking" className="text-gray-400 hover:text-white">Réservations</a></li>
              <li><a href="/shop" className="text-gray-400 hover:text-white">Boutique</a></li>
              <li><a href="/members" className="text-gray-400 hover:text-white">Espace Membres</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Suivez-nous</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Soavina Atmosphere Padel. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;